export default __webpack_public_path__ + "static/media/arrow1.540486bf.gif";